import { render, staticRenderFns } from "./SeamForm.vue?vue&type=template&id=0c6cc872&"
import script from "./SeamForm.vue?vue&type=script&lang=js&"
export * from "./SeamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports